export default {
    profileSharingConfirmDialog: {
        title: '{name} wants to see your profile',
        content: 'Do you want to share your profile with this person?',
        share: 'Share profile',
        reject: 'No',
    },
    videoDialog: {
        endCall: 'End call',
        guest: 'Guest',
        reJoin: 'Re-join',
        decline: 'Decline',
        confirmDecline: 'Confirm Decline',
        incomingCall: 'Incoming video call ...',
        onGoingCall: 'On-going call',
        activeCall: 'You have an active video call on-going, do you wish to re-join the meeting?',
    },
    videoErrorMessage: {
        endedTitle: 'Video Chat Ended',
        endedMessage: 'A video chat you participated in has ended. \nID: {id}',
    },
    chat: {
        toProfile: 'Update Profile',
        viewCompanyInfo: 'View company info',
        noChatsHeader: 'No new messages, check back soon.',
        noChatsDescription:
            'This is where messages from recruiters will be stored.\nIn the meantime, update your profile!',
    },
};
